module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PaySuccessLiteView.js"));
	}, "PaySuccessLiteView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PaySuccessLiteView!./src/pages/Shop/PayMent/PaySuccess/PaySuccessLiteView.js
// module id = 1374
// module chunks = 418